export default "__VITE_ASSET__39UJrrCt__"